import { forkJoin, Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiTransferConfigService } from './api-transfer-config.service';
import { IPagination } from 'src/app/models/generic';
import { ApiCommissionService } from './api-commission.service';
import { IStoreConfig, IStoreParameters } from 'src/app/models/storeConfig';
import { IGenericResult, ICustomSelect } from './../../models/generic';
import { environment } from 'src/environments/environment';
import { IFieldOrder } from 'src/app/models/manual-batch';

@Injectable({
  providedIn: 'root'
})
export class ApiStoreService {
  baseUrlStoreConfig = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferStoreConfig}`;

  constructor(
    private _http: HttpClient,
    private _commissionService: ApiCommissionService,
    private _manualBatchService: ApiTransferConfigService
  ) {}

  getAllStoreConfig(
    pagination: IPagination
  ): Observable<IGenericResult<IStoreConfig[]>> {
    return this._http.get<IGenericResult<IStoreConfig[]>>(
      `${this.baseUrlStoreConfig}?skip=${pagination.Skip}&take=${pagination.Take}`
    );
  }

  getAllStoreSettingsSorted(
    pagination: IPagination,
    fieldsOrder: IFieldOrder[]
    ): Observable<IGenericResult<IStoreConfig[]>> {
    //let url: string = `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.storeConfig}/Get${environment.apis.transfers.microservices.storeConfig}Sorted`;
    let url: string = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferStoreConfig}/Get${environment.apis.unified.microservices.transferStoreConfig}Sorted`;

    return this._http.post<IGenericResult<IStoreConfig[]>>(url,
      { Skip: pagination.Skip, Take: pagination.Take, FieldsOrder: fieldsOrder }
    );
  }

  saveStoreConfig(
    storeConfig: IStoreConfig
  ): Observable<IGenericResult<IStoreConfig>> {
    return this._http.post<IGenericResult<IStoreConfig>>(
      this.baseUrlStoreConfig,
      storeConfig
    );
  }

  deleteStoreConfig(storeConfigId: string): Observable<any> {
    return this._http.delete(
      `${this.baseUrlStoreConfig}?storeConfigId=${storeConfigId}`
    );
  }

  getParametersStoreConfig(): Observable<IStoreParameters> {
    const banksProducts$ = this._commissionService.getParametersCommission();
    const beneficiarieTypes$ = this._manualBatchService.getBeneficiaryTypes();

    const parameters$ = forkJoin([banksProducts$, beneficiarieTypes$]).pipe(
      map(([banksProducts, beneficiaries]) => {
        let parameters: IStoreParameters = {
          Bank: banksProducts.Data.Banks.map((bank) => {
            return { id: bank.Name, name: bank.Name };
          }),
          Product: banksProducts.Data.ProductsName.map((product) => {
            return { id: product.Name, name: product.Name };
          }),
          BeneficiaryType: [...beneficiaries],
          SaleType: ['Interna', 'Externa'].map((type) => {
            return { id: type.toLowerCase(), name: type };
          })
        };

        return parameters;
      })
    );

    return parameters$;
  }
}
